/*
  ICOLAN order flow.
  1. "Order now" on the product page (main button and sticky bar, which submit the
     same form) opens the EasySell cash-on-delivery form instead of adding to cart.
     EasySell reads the chosen bundle quantity from that form.
  2. "Order now" elsewhere ([data-ic-buy], homepage) is a plain link to the product
     page, so customers can pick a bundle first. On the product page itself it opens the form.
  3. EasySell's form text is configured in Arabic; on French and English pages the
     known strings are swapped for translations.
  If EasySell is missing, the buttons fall back to Shopify's checkout (cart permalink).
*/
(() => {
  const TRIGGER = '.es-popup-button-product';

  const rootUrl = () => {
    const root = window.Shopify?.routes?.root || '/';
    return root.endsWith('/') ? root : `${root}/`;
  };

  const trigger = () => document.querySelector(TRIGGER);

  const goToCheckout = (variantId, quantity) => {
    window.location.assign(`${rootUrl()}cart/${variantId}:${quantity}`);
  };

  // 1. Product form submit (main button + sticky bar).
  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement) || !form.matches('[data-ic-checkout]')) return;

      const data = new FormData(form);
      const variantId = String(data.get('id') || '').trim();
      const quantity = Math.max(1, parseInt(data.get('quantity'), 10) || 1);
      if (!/^\d+$/.test(variantId)) return;

      event.preventDefault();
      event.stopPropagation();

      const el = trigger();
      if (el) {
        el.click();
      } else {
        goToCheckout(variantId, quantity);
      }
    },
    true
  );

  // 2a. Homepage-style buttons: open the form directly when it is on this page.
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-ic-buy]');
    const el = link && trigger();
    if (!el) return;
    event.preventDefault();
    el.click();
  });

  // 3. French / English text for the Arabic-configured form.
  const TRANSLATIONS = {
    fr: {
      'خطوة واحدة تفصلكِ عن بشرة أحلامكِ': 'Plus qu’une étape vers la peau de vos rêves',
      'الاسم الكامل': 'Nom complet',
      'رقم الهاتف': 'Numéro de téléphone',
      'العنوان': 'Adresse',
      'المدينة': 'Ville',
      'تأكيد الطلب': 'Confirmer la commande',
      'الدفع عند الاستلام مجانًا': 'Paiement à la livraison · Livraison gratuite',
    },
    en: {
      'خطوة واحدة تفصلكِ عن بشرة أحلامكِ': 'One step away from the skin of your dreams',
      'الاسم الكامل': 'Full name',
      'رقم الهاتف': 'Phone number',
      'العنوان': 'Address',
      'المدينة': 'City',
      'تأكيد الطلب': 'Confirm my order',
      'الدفع عند الاستلام مجانًا': 'Cash on delivery · Free delivery',
    },
  };

  const lang = (document.documentElement.lang || '').slice(0, 2);
  const dictionary = TRANSLATIONS[lang];

  const translate = (root) => {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    for (let node = walker.nextNode(); node; node = walker.nextNode()) {
      const text = node.nodeValue.replace(/ /g, ' ').trim();
      if (dictionary[text]) node.nodeValue = node.nodeValue.replace(node.nodeValue.trim(), dictionary[text]);
    }
    for (const input of root.querySelectorAll('input[placeholder]')) {
      const value = input.placeholder.trim();
      if (dictionary[value]) input.placeholder = dictionary[value];
    }
  };

  // EasySell writes its button colours inline with !important, which no stylesheet
  // can beat, so the ICOLAN look (black pill, gold subtitle) is applied here.
  const BUTTON_STYLE = {
    background: '#161616',
    'border-color': '#161616',
    'border-radius': '999px',
    'box-shadow': '0 14px 30px -12px rgba(22, 22, 22, 0.55)',
    'font-size': '18px',
  };

  const styleButton = (modal) => {
    const button = modal.querySelector('#es-form-button');
    if (!button) return;
    for (const [property, value] of Object.entries(BUTTON_STYLE)) {
      if (button.style.getPropertyValue(property) !== value) button.style.setProperty(property, value, 'important');
    }
    const subtitle = button.querySelector('.es-button-subtitle');
    if (subtitle && subtitle.style.getPropertyValue('color') !== 'rgb(233, 201, 119)') {
      subtitle.style.setProperty('color', 'rgb(233, 201, 119)', 'important');
    }
  };

  const refresh = (modal) => {
    styleButton(modal);
    if (dictionary) translate(modal);
  };

  const watchForm = () => {
    const modal = document.getElementById('easysell-modal');
    if (!modal) return false;
    refresh(modal);
    new MutationObserver(() => refresh(modal)).observe(modal, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['style'],
    });
    return true;
  };

  const start = () => {
    if (watchForm() === false) {
      // EasySell renders its modal after page load.
      const observer = new MutationObserver(() => {
        if (watchForm()) observer.disconnect();
      });
      observer.observe(document.body, { childList: true, subtree: true });
      setTimeout(() => observer.disconnect(), 15000);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
